import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiFetcher } from "../ApiProvider";
import { QUERY_KEYS } from "../queryKeys";
import type { Task, CreateTaskInput, ExternalTaskSource } from "../types";
export function useCreateTodoTask(externalSourceName) {
  const $ = _c(10);
  const apiFetcher = useApiFetcher();
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== apiFetcher) {
    t0 = data => apiFetcher("/api/v1/tasks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });
    $[0] = apiFetcher;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  let t2;
  if ($[2] !== externalSourceName || $[3] !== queryClient) {
    t1 = async () => {
      await queryClient.cancelQueries({
        queryKey: [...QUERY_KEYS.externalTasks(externalSourceName ?? "")]
      });
    };
    t2 = () => {
      queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.tasks.all()
      });
      if (externalSourceName) {
        queryClient.invalidateQueries({
          queryKey: [...QUERY_KEYS.externalTasks(externalSourceName)]
        });
      }
    };
    $[2] = externalSourceName;
    $[3] = queryClient;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = {
      mutationFn: t0,
      onMutate: t1,
      onSuccess: t2
    };
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return useMutation(t3);
}
export function useDeleteTask(externalSourceName) {
  const $ = _c(8);
  const apiFetcher = useApiFetcher();
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== apiFetcher) {
    t0 = id => apiFetcher(`/api/v1/tasks/${id}`, {
      method: "DELETE"
    });
    $[0] = apiFetcher;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== externalSourceName || $[3] !== queryClient) {
    t1 = () => {
      queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.tasks.all()
      });
      if (externalSourceName) {
        queryClient.invalidateQueries({
          queryKey: [...QUERY_KEYS.externalTasks(externalSourceName)]
        });
      }
    };
    $[2] = externalSourceName;
    $[3] = queryClient;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0 || $[6] !== t1) {
    t2 = {
      mutationFn: t0,
      onSuccess: t1
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useMutation(t2);
}